"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyTransition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intersection_observer_1 = require("react-intersection-observer");
var transition_1 = require("./transition");
exports.LazyTransition = function (props) {
    var inViewOptions = props.inViewOptions, animateOnMount = props.animateOnMount, children = props.children;
    var _a = react_intersection_observer_1.useInView(inViewOptions), inViewRef = _a[0], inView = _a[1], entry = _a[2];
    var observerWait = !entry && animateOnMount;
    return (react_1.default.createElement(transition_1.Transition, tslib_1.__assign({}, props, { inViewRef: inViewRef, disabled: !inView }), observerWait ? null : children));
};
exports.LazyTransition.displayName = "LazyTransition";
